module.exports = __webpack_public_path__ + "img/roundedh3xlogo.1b4f0d8f.svg";